import { Helmet } from 'react-helmet-async';

import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

// @mui
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import PropTypes from 'prop-types';
import {
  DeleteAttachment,
  DownloadTreeAttachment,
  GetAttachmentsList,
  PostAttachment,
} from 'src/components/services/httpServices';

import { Download, Trash } from 'react-feather';
import ModalLayout from 'src/theme/Modal';
import PdfViewerModal from './PdfViewerModal';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function AttachmentsList(props) {
  let { id, checkClient } = useParams();

  const [attachments, setAttachments] = useState({});
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('sdsdsdsds');
  const [scannedDate, setScannedDate] = useState(null);
  const [selectedFile, setSelectedFile] = useState([]);

  const attachmentRef = useRef(null);
  const scannedDateRef = useRef(null);
  const fetchAttachments = async (event) => {
    const attachments = await GetAttachmentsList(id, checkClient);
    setAttachments(attachments);
    setLoading(false);
  };
  useEffect(() => {
    fetchAttachments();
  }, [selectedFile]);

  const handleClose = () => {
    setOpen(false);
  };
  const SaveAttachment = async (event) => {
    event.preventDefault();

    setLoading(true);
    var payload = selectedFile;
    //  console.log(payload);

    let response = await PostAttachment(id, payload, checkClient);

    //  console.log('PostResponse:', response);
    if (response.status == 200) {
      fetchAttachments();
      setSelectedFile([]);
      props.setMessage(response.data);
      props.setSaved(true);
      props.setOpen(true);
      setLoading(false);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };
  const uploadFile = (event) => {
    event.preventDefault();
    const uploaded = [...selectedFile];
    for (let i = 0; i < event.target.files.length; i++) {
      let reader = new FileReader();
      let file = event.target.files[i];
      // console.log('FileName', file); //I can see the file's info

      reader.onload = (event) => {
        //  console.log('event', event.target.result[i]);
        // console.log("asas", reader.result);
        const row = {
          attachment: reader.result,
          fileName: file.name,
          docType: '',
          scannedDate: currentDateStr,
          docExpiryDate: '',
        };
        uploaded.push(row);
        // setSelectedFile(uploaded);
        // console.log('row', row);
        // console.log("State", selectedFile);
      };
      reader.readAsDataURL(file);

      // console.log('asas', reader.result);
      reader.onerror = function (error) {
        //     console.log('Error: ', error);
      };
    }
    setSelectedFile(uploaded);
  };
  const deleteAttachmentRow = (fileName) => {
    // console.log(selectedFile);
    const newList = selectedFile.filter((item) => item.fileName !== fileName);
    //  console.log('new List', newList);

    // setGrandTotal(parseInt(grandTotal) - price * quantity);
    setSelectedFile(newList);
  };

  const deleteAttachment = async (attachment) => {
    event.preventDefault();
    setLoading(true);

    // console.log('IDD:', attachment);
    let response = await DeleteAttachment(attachment);
    // console.log('Console:', response);
    if (response.status == 200) {
      const newList = attachments.filter((item) => item.id !== attachment);
      setAttachments(newList);
      props.setMessage(response.data);
      props.setSaved(true);
      props.setOpen(true);
      setLoading(false);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
    }
  };
  const GetAttachment = async (path) => {
    //var file = await DownloadAttachment(path);
    var file = await DownloadTreeAttachment('1', false, '', path, false);
    console.log('path:', path);
    const url = window.URL.createObjectURL(new Blob([file.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', path); //or any other extension
    document.body.appendChild(link);
    link.click();
  };

  const ChangeDateHandle = (event, index) => {
    selectedFile[index].scannedDate = event.target.value;
    setScannedDate(event.target.value);
    //  console.log(index);
    console.log(event.target.value);
    //  console.log(selectedFile);
  };
  const ChangeDocTypeHandle = (event, index, type) => {
    //  console.log(index);
    //  console.log(type);
    selectedFile[index].docType = type?.value;
  };
  const ChangeExpiryDateHandle = (event, index) => {
    selectedFile[index].docExpiryDate = event.target.value;
    // console.log(selectedFile);
  };
  const docTypes = [
    { value: 'Permit' },
    { value: 'Communication' },
    { value: 'Submission' },
    { value: 'Questionnaire' },
    { value: 'Fee Receipt' },
    { value: 'Invoice' },
    { value: 'Passport' },
    { value: 'Work permit' },
    { value: 'LMIA' },
    { value: 'Education' },
    { value: 'Employment reference' },
    { value: 'Alberta job offer' },
    { value: 'Pay stubs' },
    { value: 'Proof of funds' },
    { value: 'Dependent form' },
    { value: 'Use of rep' },
    { value: 'Questionnaire' },
    { value: 'T4 summary' },
    { value: 'Attestation letter' },
    { value: 'Additional Documents' },
  ];

  const currentDate = new Date();
  const currentHour = currentDate.getHours().toString().padStart(2, '0');
  const currentMinute = currentDate.getMinutes().toString().padStart(2, '0');
  const currentTime = `${currentHour}:${currentMinute}:00`;

  const currentYear = currentDate.getFullYear().toString();
  const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // add 1 to get the correct month
  const currentDay = currentDate.getDate().toString().padStart(2, '0');
  const currentDateStr = `${currentYear}-${currentMonth}-${currentDay}`;
  return (
    <>
      <Helmet>
        <title> Documents | Immigration System </title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Add Documents
          </Typography>
          <Typography variant="h4" marginRight={12} gutterBottom></Typography>
          <Typography variant="h4" marginRight={12} gutterBottom></Typography>
          <Typography variant="h4" marginRight={12} gutterBottom></Typography>
          <Typography variant="h4" marginRight={12} gutterBottom></Typography>

          <TextField
            type="file"
            label=""
            inputProps={{ multiple: true }}
            inputRef={attachmentRef}
            onChange={uploadFile}
          />
          {/* <Button
            onClick={() => {
              navigate(-1);
            }}
            variant="contained"
          >
            Back
          </Button> */}
          <Button onClick={SaveAttachment} variant="contained">
            Save
          </Button>
        </Stack>
        <Box
          p={3}
          component={Paper}
          boxShadow={3}
          marginBottom={4}
          sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <br></br>
              <br></br>
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Sr#</TableCell>

                      <TableCell>Attachment Name</TableCell>
                      <TableCell>Scanned Date</TableCell>
                      <TableCell>Document Type</TableCell>
                      <TableCell>Document Expiry Date</TableCell>
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedFile?.map((row, index) => (
                      <TableRow key={index + 1}>
                        <TableCell>{index + 1}</TableCell>

                        <TableCell>{row.fileName}</TableCell>

                        <TableCell>
                          <TextField
                            label="Scaned Date"
                            variant="outlined"
                            fullWidth
                            defaultValue={currentDateStr}
                            size="small"
                            type="date"
                            onChange={(event) => ChangeDateHandle(event, index)}
                            InputLabelProps={{ shrink: true }}
                          />{' '}
                        </TableCell>

                        <TableCell>
                          <Autocomplete
                            id="docType"
                            size="small"
                            options={docTypes}
                            // defaultValue={userList.find((e) => e.key == user.deptId)}
                            getOptionLabel={(source) => source.value}
                            renderInput={(params) => <TextField {...params} label="Doc Type" variant="outlined" />}
                            onChange={(event, type) => ChangeDocTypeHandle(event, index, type)}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            label="Doc Expiry Date"
                            variant="outlined"
                            fullWidth
                            size="small"
                            type="date"
                            onChange={(event) => ChangeExpiryDateHandle(event, index)}
                            InputLabelProps={{ shrink: true }}
                          />{' '}
                        </TableCell>
                        <TableCell>
                          <IconButton
                            onClick={() => deleteAttachmentRow(row.fileName)}
                            aria-label="delete"
                            size="small"
                          >
                            <Trash />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Box>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Saved Documents
          </Typography>
        </Stack>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Box
            p={4}
            component={Paper}
            boxShadow={3}
            sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <br></br>
                <br></br>
                <TableContainer component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Sr#</TableCell>
                        <TableCell>Document Name</TableCell>

                        <TableCell>Scanned Date</TableCell>
                        <TableCell>Document Type</TableCell>
                        <TableCell>Document Expiry</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {attachments?.map((row, index) => (
                        <TableRow key={index + 1}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{row.docName}</TableCell>
                          {/* <TableCell>{row.name}</TableCell> */}
                          {/* <TableCell>
                            <Link
                              href="#"
                              // onClick={() => {
                              //   window.open(`C:\Attachment Folder\ ${row.name}, '_blank`);
                              // }}
                              onClick={() => GetAttachment(row.name)}
                            >
                              {row.name}
                            </Link>
                          </TableCell> */}
                          <TableCell>{row.scannedDate?.split('T')[0]}</TableCell>
                          <TableCell>{row.docType}</TableCell>
                          <TableCell>{row.docExpiryDate?.split('T')[0]}</TableCell>
                          <TableCell>
                            <IconButton size="small">
                              <PdfViewerModal file={row.name} filePath={row.path} treeView={false} title="View" />
                            </IconButton>
                            {/* <IconButton onClick={() => GetAttachment(row.name)} aria-label="delete" size="small">
                              <Download />
                            </IconButton> */}
                            <IconButton onClick={() => GetAttachment(row.path)} aria-label="delete" size="small">
                              <Download />
                            </IconButton>
                            <IconButton aria-label="delete" size="small">
                              <ModalLayout
                                // title="Delete"
                                component={<Trash />}
                                description="Are You Sure you want to Delete?"
                                Hit={() => deleteAttachment(row.id)}
                              />
                              {/* <Trash borderColor='red' /> */}
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Box>
        )}
      </Container>
      {saved ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
            {message}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
            {message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
